import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'igo-bookmark-dialog',
  template: require('./bookmark-dialog.component.html'),
})
export class BookmarkDialogComponent {

  public title: string;

  constructor(public dialogRef: MatDialogRef<BookmarkDialogComponent>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/bookmark-button/bookmark-dialog.component.ts